<template>
  <div>
    <v-toolbar color="teal" dark v-touch="{ right: () => this.drawer = !this.drawer }">
      <v-btn v-if="$route.path.indexOf('chat/') > 0" dark icon
             @click="goToCommunity($route.params.communityId + '/chat')">
        <v-icon medium>chevron_left</v-icon>
      </v-btn>
      <v-btn v-else-if="$route.path.indexOf('topic/') > 0" dark icon
             @click="goToCommunity($route.params.communityId)">
        <v-icon medium>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-side-icon v-else class="white--text"
                           @click="drawer = !drawer"></v-toolbar-side-icon>

      <v-toolbar-title class="white--text" v-html="communityName"></v-toolbar-title>

      <v-spacer></v-spacer>

      <!--<v-btn icon>-->
        <!--<v-icon color="white">search</v-icon>-->
      <!--</v-btn>-->

      <v-btn v-if="!user" color="white" dark class="teal--text"
             @click="singInDialog = true">Sign In</v-btn>
      <template v-else>
        <div class="text-xs-center">
          <v-menu offset-y class="mr-2">
            <v-btn flat icon color="white" slot="activator">
              <v-badge overlap color="orange">
                <span slot="badge">6</span>
                <v-icon>far fa-bell</v-icon>
              </v-badge>
            </v-btn>
            <v-list>
              <v-list-tile v-for="(item, index) in [ { title: 'Click Me' }
            , { title: 'Click Me' }, { title: 'Click Me' },  { title: 'Click Me 2' } ]"
                           :key="index" @click="goToCommunity">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>

        <v-avatar size="32">
          <img :src="user.photoURL" :alt="user.displayName">
        </v-avatar>

        <v-menu bottom left>
          <v-btn icon dark slot="activator">
            <v-icon color="white">more_vert</v-icon>
          </v-btn>

          <v-list>
            <v-list-tile>
              <v-list-tile-title>{{ user.displayName }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="signOut">
              <v-list-tile-title>Sign Out</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
    </v-toolbar>

    <v-dialog v-model="singInDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Sign In With</v-card-title>
        <v-card-text>
          <v-btn block round class="white--text" style="background-color: #00aced"
                 @click="signInWithTwitter"><v-icon left>fab fa-twitter</v-icon>Twitter</v-btn>
          <v-btn block round class="white--text" style="background-color: #3b5998"
                 @click="signInWithFacebook"><v-icon left>fab fa-facebook</v-icon>Facebook</v-btn>
<!--          <v-btn block round class="white&#45;&#45;text" style="background-color: #ea4335"
                 @click="signInWithGoogle"><v-icon left size="">fab fa-google</v-icon>Google
          </v-btn>-->
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-navigation-drawer v-model="drawer" absolute temporary style="z-index: 2000;">
      <v-list class="pa-1 teal">
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title class="title white--text">Menu</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list class="pt-0" dense>
        <v-list-tile @click="gotoCommunityList">
          <v-list-tile-action>
            <v-icon class="teal--text">dashboard</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Top</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-group prepend-icon="group_work" no-action value="true">
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>Community Space</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile v-for="(community, index) in communities" :key="index"
                       @click="goToCommunity(community.id)">
            <v-list-tile-content>
              <v-list-tile-title v-html="community.name"></v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon></v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Header',
  data() {
    return {
      user: undefined,
      singInDialog: false,
      drawer: false,
      communities: [
        { name: 'LollSpace Community(&alpha;)', id: 'lollspace-alpha' },
        { name: 'Hello, My Space!', id: 'niishi.kubo' },
        // { name: 'Firebase User Group', id: 'firebase' },
        { name: 'Spotify User Community JP', id: 'spotify' },
        { name: 'kojin-dev [個人開発者同士のコミュニティ]', id: 'kojin-dev' },
      ],
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      this.user = user ? user : undefined;
    });
  },
  computed: {
    communityName() {
      return this.$store.state.communityName;
    },
  },
  methods: {
    gotoCommunityList() {
      this.$router.push('/');
      this.drawer = false;
    },
    goToCommunity(path) {
      this.$router.push(`/c/${path}`);
      this.drawer = false;
    },
    signInWithTwitter() {
      const twitterProvider = new firebase.auth.TwitterAuthProvider();
      firebase.auth().signInWithRedirect(twitterProvider);
    },
    signInWithFacebook() {
      const facebookProvider = new firebase.auth.FacebookAuthProvider();
      firebase.auth().signInWithRedirect(facebookProvider);
    },
    signInWithGoogle() {
      const googleProvider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithRedirect(googleProvider);
    },
    signOut() {
      firebase.auth().signOut();
    },
  },
};
</script>

<style>
  .v-list__group__header--active .v-list__group__header__prepend-icon .v-icon {
    color: #009688 !important;
  }
  /*.v-overlay {*/
    /*z-index: 1700;*/
  /*}*/
</style>
